// src-lit/components/product/kd-product-deal-reason.ts
import { customElement } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';
import { KdVariantSyncedElement } from './kd-variant-synced-element';

interface DealReasonVariantEntry {
  /** type/本文が揃って表示対象になっているか。false ならセクション wrapper を hidden */
  shouldRender: boolean;
  /** snippet v2-deal-reason の事前レンダリング済み HTML。Lit は outerHTML で差し替えるだけ（二重化禁止） */
  contentHtml: string;
}

/**
 * @element kd-product-deal-reason
 * @description おトクな背景セクションをバリアント選択に応じて差し替える。
 *   セクション wrapper（[data-deal-reason-section]）の hidden を toggle し、snippet
 *   v2-deal-reason のルート要素を per-variant スニペット出力で outerHTML 差し替えする。
 *   wrapper を Custom Element 自体に置かないのは、custom element に display: block 系の
 *   author CSS が当たると UA の [hidden]{display:none} を上書きしてしまうため
 *   （kd-product-shipping と同じ pattern）。
 *   文字列生成は Liquid 側（snippet）で済ませて variant-map JSON に載せる方針（二重化禁止）。
 */
@customElement('kd-product-deal-reason')
export class KdProductDealReason extends KdVariantSyncedElement<DealReasonVariantEntry> {
  protected readonly variantMapSelector = SELECTORS.PRODUCT_DEAL_REASON.VARIANT_MAP;

  protected onVariantSelected(entry: DealReasonVariantEntry): void {
    const section = this.querySelector<HTMLElement>(
      SELECTORS.PRODUCT_DEAL_REASON.SECTION,
    );
    if (!section) return;

    section.hidden = !entry.shouldRender;
    if (!entry.shouldRender) return;

    const content = section.querySelector<HTMLElement>(
      SELECTORS.PRODUCT_DEAL_REASON.CONTENT,
    );
    // outerHTML で snippet 出力をまるごと置換。置換後の要素も同じ data 属性を持つので次回も querySelector で拾える。
    if (content) content.outerHTML = entry.contentHtml;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-product-deal-reason': KdProductDealReason;
  }
}
